import { GeneralObject } from '~/types/CommonTypes';
import { MySsApiResponse } from '~/types/MySsApiResponse';
import { TransactionListFiltersDto } from '~/models/Transaction';
import { get } from '~http';

const baseUrl = 'rewards-accounts';

export async function getBalance(companyDocument: string) {
  return await get(`${baseUrl}/${companyDocument}/balance`, {}).then(
    ({ data }: MySsApiResponse) => data,
    (error) => {
      throw error;
    },
  );
}

export async function getTransactions(
  companyDocument: string,
  params: TransactionListFiltersDto = { ...new TransactionListFiltersDto() },
) {
  return await get(`${baseUrl}/${companyDocument}/transaction`, params).then(
    ({ data }: MySsApiResponse) => data,
    (error) => {
      throw error;
    },
  );
}

export async function getRedemptions(
  companyDocument: string,
  params: GeneralObject = {},
) {
  return await get(`${baseUrl}/${companyDocument}`, params).then(
    ({ data }: MySsApiResponse) => data,
    (error) => {
      throw error;
    },
  );
}

export async function makeARansomRequest(data: any) {
  return await post(`rewards-accounts`, data).then(
    ({ data }: MySsApiResponse) => data,
    (error) => {
      const err = errorTreatment(error);
      throw err;
    },
  );
}
